import React, { useState, useEffect } from 'react';
import Spiner from '../components/Admin/Spiner/Spiner';
import { Outlet } from 'react-router-dom';
import Auth from '../components/Admin/Auth/Auth';
import baseURL from '../components/url';
import { adminFetch, getAdminToken, initAdminTokenRefresh } from '../utils/api';
export default function MainLayout({ logo }) {
    const [usuario, setUsuario] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Sin token no hace falta ir al servidor — mostrar login de inmediato
        if (!getAdminToken()) {
            setLoading(false);
            return;
        }

        initAdminTokenRefresh(baseURL);

        const fetchData = async () => {
            try {
                const response = await adminFetch(`${baseURL}/api/admin/me`);
                if (!response.ok) {
                    setLoading(false);
                    return;
                }
                const data = await response.json();
                setUsuario(data.usuario || data);
            } catch (error) {
                // red caída u otro error — deja usuario vacío → mostrará Auth
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <div>
            {loading ? (
                <Spiner logo={logo} />
            ) : usuario.idUsuario ? (
                <Outlet />
            ) : (
                <Auth logo={logo} />
            )}
        </div>
    );
}
